import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations/translations';
import '../styles/footer.css';

const Footer = () => {
  const { language } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-contact">
            <div className="contact-content">
              <p className="contact-name">Pawilon Krzyżanowskiego</p>
              <p className="contact-address">Ul. Garbary 96</p>
              <p className="contact-address">61-757 Poznań, PL</p>
            </div>
          </div>
        </div>
        
        <div className="footer-center">
          <div className="footer-contact">
            <div className="contact-content">
              <p className="contact-phone">532 883 067</p>
              <p className="contact-email">garbary96@gmail.com</p>
              <a href="https://instagram.com/garbary96" className="social-link">instagram</a>
            </div>
          </div>
        </div>
        
        <div className="footer-center-right">
          <div className="footer-nav-section">
                    <div className="footer-nav">
                      <Link to="/events" className="nav-link">{t('nav.events', language).toLowerCase()}</Link>
                      <Link to="/private-events" className="nav-link">{t('nav.privateEvents', language).toLowerCase()}</Link>
                      <Link to="/the-venue" className="nav-link">{t('nav.venue', language).toLowerCase()}</Link>
                      <Link to="/contact" className="nav-link">{t('nav.contact', language).toLowerCase()}</Link>
                    </div>
          </div>
        </div>
        
        <div className="footer-right">
          <div className="footer-logo">
            <img 
              src="/assets/PawilonLogo5E.svg" 
              alt="Pawilon Logo" 
              className="logo"
            />
          </div>
        </div>
      </div>
      
      <div className="footer-copyright">
        <div className="copyright-content">
          <div className="copyright-left">
            <p className="copyright-text">© {new Date().getFullYear()} Pawilon Krzyżanowskiego. {t('footer.rights', language)}</p>
          </div>
          <div className="copyright-line"></div>
          <div className="copyright-right">
            <Link to="/privacy" className="location-text">{t('footer.privacy', language)}</Link>
            <Link to="/terms" className="location-text" style={{marginLeft: '0.8rem'}}>{t('footer.terms', language)}</Link>
          </div>
        </div>
        <div className="footer-title">
          <h2 className="title-text">KRZYŻANOWSKIEGO</h2>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
